import { EpimsBaseEntityDto } from "./epim-base.dto";

export class IncidentPartyInvolvedDto extends EpimsBaseEntityDto {
  PartyInvolvedName: string;
  SubscriptionUserId: string;  
  Version: number;
}